import { Grid, Link } from "@mui/material";
import type { FC } from "react";
import { PageCard } from "../../generic/components/page-card";
import { CsvUploadCard } from "./csv-upload-card";

export const CsvUpload: FC<{ onUpload: () => Promise<void>; onComplete: () => void }> = ({
  onUpload,
  onComplete,
}) => {
  return (
    <PageCard
      title="Upload CSV"
      subTitle={
        <div>
          <Link
            href="https://help.changeengine.com/Managing-Employee-Data-via-CSV-86de53e697e24e26a05bc638e57923a7"
            target="_blank"
            rel="noreferrer"
            underline="hover"
          >
            Learn more
          </Link>
          &nbsp;about using our upload function
        </div>
      }
      withMargin={false}
    >
      <Grid container>
        <Grid size={{ xs: 4 }}>
          <CsvUploadCard
            processingState="not started"
            onUpload={onUpload}
            onComplete={onComplete}
          />
        </Grid>
      </Grid>
    </PageCard>
  );
};
